export default {
  title: 'Receber folhetos mensais automáticos',
  status: {
    enabled: 'Ativado',
    disabled: 'Desativado',
  },
  opt_out: {
    on_hint: 'O seu plano Foodamigos inclui 500 folhetos gratuitos por mês. Desative para deixar de os receber.',
    off_hint: 'Os folhetos automáticos estão pausados. Ative para retomar a partir do próximo mês.',
    confirm_off: {
      title: 'Desativar folhetos automáticos?',
      body: 'Ao desativar, {{location}} não receberá folhetos automáticos a partir do próximo mês. As encomendas existentes não são afetadas.',
      confirm: 'Desativar',
      cancel: 'Manter ativo',
    },
  },
  approved_design: {
    label: 'Design aprovado para folhetos mensais',
    auto_option: 'Automático (encomendado mais recentemente)',
    flyer_slot: 'Folheto {{slot}}',
    custom: 'Personalizado',
    untitled: 'Sem título',
    invalid_warning:
      'O design guardado já não está disponível. O folheto encomendado mais recentemente será usado até selecionar um novo.',
  },
  toasts: {
    failed_to_load: 'Falha ao carregar as definições de folheto automático',
    failed_to_save: 'Falha ao guardar alterações',
    saved: 'Alterações guardadas',
  },
};
